export {
  ProgressBar,
  type ProgressBarProps,
} from '../../compositions/shared/ProgressBar';
